const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgPepper17(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 111.64 111.64",
    style: {
      enableBackground: "new 0 0 111.64 111.64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st2{fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:#050505;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#0C9AF0;}\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:#0C9AF0;}\n\t.st9{fill:none;stroke:#0C9AF0;stroke-width:2;stroke-miterlimit:10;}\n\t.st10{stroke:#0C9AF0;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st11{stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n"), /*#__PURE__*/React.createElement("g", {
    id: "Thin-S_25_",
    transform: "matrix(1 0 0 1 804.371 696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-779.91-597.41h63.87c6.54,0,10.16-3.66,10.16-10.5v-39.4c0-6.84-3.61-10.5-10.55-10.5h-37.26 c-3.22,0-4.69-0.49-6.79-2.39l-2.05-1.86c-2.54-2.34-4.05-2.83-7.96-2.83h-10.84c-6.01,0-9.13,3.08-9.13,9.38v47.61 C-790.46-600.98-786.84-597.41-779.91-597.41z M-787.14-655.22c0-4.35,2.1-6.45,6.4-6.45h9.57c3.08,0,4.49,0.49,6.64,2.54l2.1,1.86 c2.34,2.15,4.1,2.78,8.06,2.78h37.84c4.64,0,7.32,2.49,7.32,7.37v3.66h-77.93V-655.22z M-779.81-600.73 c-4.79,0-7.32-2.49-7.32-7.37v-32.18h77.93v32.23c0,4.83-2.69,7.32-7.32,7.32H-779.81z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPepper17);
export default __webpack_public_path__ + "static/media/pepper-17.411d8b6443ee62a4e7406dc4e83cbf15.svg";
export { ForwardRef as ReactComponent };